import { ChakraProvider } from '@chakra-ui/react';
import '@fontsource/ibm-plex-sans';
import Amplify from 'aws-amplify';
import 'focus-visible/dist/focus-visible';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import amplifyConfig from './aws-exports';
import theme from './components/common/theme';
import reportWebVitals from './reportWebVitals';
import store from './stores';
import { setupI18n } from './utils/i18n';

Amplify.configure(amplifyConfig);

setupI18n();

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <Provider store={store}>
        <App />
      </Provider>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
